import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  ProcessOption,
  API_PATH_PROCESS_OPTIONS,
} from './processOption.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();
export function getProcessOptionsList(
  deliveryFunctionId: string,
): AxiosPromise<ServerResponse<ProcessOption>> {
  return http.get(`${API_PATH_PROCESS_OPTIONS}/${deliveryFunctionId}`);
}

export function getProcessOptions(
  deliveryFunctionId: string, id: string,
): AxiosPromise<ServerResponse<ProcessOption>> {
  return http.get(`${API_PATH_PROCESS_OPTIONS}/${deliveryFunctionId}/${id}`);
}

export function createProcessOptions(
  deliveryFunctionId: string,
  body: WithAuditDetails<ProcessOption>,
): AxiosPromise<ServerResponse<ProcessOption>> {
  return http.post(`${API_PATH_PROCESS_OPTIONS}/${deliveryFunctionId}`, body);
}

export function updateProcessOptions(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<ProcessOption>,
): AxiosPromise<ServerResponse<ProcessOption>> {
  return http.put(`${API_PATH_PROCESS_OPTIONS}/${deliveryFunctionId}/${id}`, body);
}

export function deleteProcessOptions(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<void>,
): AxiosPromise<ServerResponse<ProcessOption>> {
  return http.delete(`${API_PATH_PROCESS_OPTIONS}/${deliveryFunctionId}/${id}`, { data: body.auditDetails });
}
